import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getForWeb } from 'redux/settings/actions';
import Widgets from 'widgets/Widgets';

import InvalidTenant from './InvalidTenant';

const NoApp = () => {
  const [isInvalidTenant, setIsInvalidTenant] = useState(false);
  const dispatch = useDispatch();
  const setting = useSelector((state) => state.setting.data);

  useEffect(() => {
    const onError = () => {
      setIsInvalidTenant(true);
    };
    dispatch(getForWeb(onError));
  }, [dispatch]);

  if (!setting) {
    return null;
  }

  if (isInvalidTenant) {
    return <InvalidTenant />;
  }

  return (
    <div>
      <Widgets />
    </div>
  );
};

export default NoApp;
